export default "__VITE_ASSET__CG_5TKrC__"